<template>
	<div>
		<a-page-header style="background: #fff;" title="商品详情" />
		<div style="background: #fff;padding:20px">
			<a-form-model ref="form" :model="form" :rules="formRules" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }">
				<a-form-model-item label="商品名称" prop="goodsName">
					<a-input v-model="form.goodsName" placeholder="请输入商品名称" />
				</a-form-model-item>
				<a-form-model-item label="商品分类" prop="goodsClass">
					<a-cascader :options="goodsClassList" placeholder="请选择商品类型" v-model="form.goodsClass" />
				</a-form-model-item>
				<a-form-model-item label="商品缩略图" prop="goodsThumb">
					<a-upload name="img" listType="picture-card" class="avatar-uploader" :showUploadList="false" :action="this.$host+'/admin/index.php/admin/qiniu/uploads'"
					 @change="goodsThumbChange">
						<img v-if="form.goodsThumb" :src="form.goodsThumb" alt="avatar" style="width: 150px;height: 150px;" />
						<div v-else>
							<a-icon :type="loading ? 'loading' : 'plus'" />
							<div class="ant-upload-text">上传</div>
						</div>
					</a-upload>
					<div style="color: #ffa940;">建议上传350px * 350px的方形图片 尺寸过大会影响商品列表加载速度</div>
				</a-form-model-item>
				<a-form-model-item label="商品图片" prop='goodsPic'>
					<a-upload name="img" :multiple="true" listType="picture-card" class="avatar-uploader" :action="this.$host+'/admin/index.php/admin/qiniu/uploads'"
					 :file-list="fileList" @preview="handlePreview" @change="photoChange">
						<div>
							<a-icon :type="loading ? 'loading' : 'plus'" />
							<div class="ant-upload-text">上传</div>
						</div>
					</a-upload>
					<div style="color: #ffa940;">建议上传750px * 750px的方形图片 尺寸过大会影响商品列表加载速度</div>
				</a-form-model-item>
				<a-form-model-item label="商品简介" prop="goodsCont">
					<a-input v-model="form.goodsCont" placeholder="请输入商品简介" />
				</a-form-model-item>
				<a-form-model-item label="商品单位" prop="goodsUnit">
					<a-input v-model="form.goodsUnit" style="width: 150px;" placeholder="请输入商品单位" />
				</a-form-model-item>
				<a-form-model-item label="商品规格" prop='isSpecs'>
					<a-radio-group v-model="form.isSpecs" button-style="solid">
						<a-radio-button :value="1">单规格</a-radio-button>
						<a-radio-button :value="2">多规格</a-radio-button>
					</a-radio-group>
					<a-button style="margin-left: 20px;" @click="addSpecsModal = true" v-if="form.isSpecs == 2">+ 添加规格</a-button>
				</a-form-model-item>

				<!-- 单规格 -->
				<a-row style="padding-top:24px ;margin-bottom: 24px;" v-if="form.isSpecs == 1">
					<a-col :span="12">
						<a-form-model-item label="售价" prop="goodsPrice" required :label-col="{ span: 5, offset: 5 }" :wrapper-col="{ span: 10 }">
							<a-input v-model="form.goodsPrice" placeholder="请输入商品售价" suffix="元" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="原价" prop="goodsOldPrice" :label-col="{ span: 5}" :wrapper-col="{ span: 9 }">
							<a-input v-model="form.goodsOldPrice" placeholder="请输入商品原价" suffix="元" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="库存" prop="goodsInventory" :label-col="{ span: 5, offset: 5 }" :wrapper-col="{ span: 10 }">
							<a-input v-model="form.goodsInventory" placeholder="请输入商品库存" :suffix="form.goodsUnit" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="送积分" prop="goodsIntegral" :label-col="{ span: 5}" :wrapper-col="{ span: 9 }">
							<a-input v-model="form.goodsIntegral" placeholder="请输入赠送积分" suffix="积分" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<!-- 单规格end -->

				<!-- 多规格 -->
				<div v-if="form.isSpecs == 2">
					<a-form-model-item :wrapper-col="{ span: 14, offset: 5 }">
						<a-table :columns="columns" :data-source="specsList" rowKey="id">
							<span slot="goodsPrice" slot-scope="goodsPrice">
								{{goodsPrice}} 元
							</span>	
							<span slot="goodsOldPrice" slot-scope="goodsOldPrice">
								{{goodsOldPrice}} 元
							</span>		
							<span slot="goodsInventory" slot-scope="text,goodsInventory">
								{{goodsInventory.goodsInventory}} {{form.goodsUnit}}
							</span>		
							<span slot="goodsIntegral" slot-scope="goodsIntegral">
								{{goodsIntegral}} 积分
							</span>			
							<span slot="action" slot-scope="text,action">
								<a style="color:#40a9ff ;" @click="viewSpecs(action.id)">编辑</a>
								<a-divider type="vertical" />
								<a-popconfirm title="请确认是否删除？" okText="是" cancelText="否" @confirm="delSpecs(action.id)">
									<a style="color: #ff4d4f;">删除</a>
								</a-popconfirm>
							</span>
						</a-table>
					</a-form-model-item>
				</div>
				<!-- 多规格end -->
				
				<!-- <a-form-model-item label="送达时间" prop='goodsDelivery'>
					<a-radio-group v-model="form.goodsDelivery" button-style="solid">
						<a-radio-button :value="1">现货</a-radio-button>
						<a-radio-button :value="2">隔日到(需预约)</a-radio-button>
					</a-radio-group>
				</a-form-model-item> -->
				<a-form-model-item label="虚拟销量" prop='goodsVirtualSales'>
					<a-input v-model="form.goodsVirtualSales" placeholder="请输入虚拟销量" style="width: 150px;"></a-input>
				</a-form-model-item>
        <a-form-model-item label="商品排序" prop='sort'>
        	<a-input v-model="form.sort" placeholder="请输入商品排序" style="width: 150px;"></a-input>
        </a-form-model-item>
				<a-form-model-item label="是否上架" prop='isOpen'>
					<a-switch checked-children="是" un-checked-children="否" v-model="form.isOpen" />
				</a-form-model-item>
				<a-form-model-item label="图文详情" prop='goodsContent'>
					<tinymce ref="content" v-model="form.goodsContent" />
				</a-form-model-item>
				<a-form-model-item :wrapper-col="{ span: 14, offset: 5 }">
					<a-button type="primary" @click="basicSubmit">
						保存
					</a-button>
				</a-form-model-item>
			</a-form-model>
		</div>

		<!-- 添加规格 -->
		<a-modal title="添加规格" v-model="addSpecsModal" @ok="addSpecsSubmit" cancelText="取消" okText="添加" width="50%">
			<a-form-model ref="specsForm" :model="specsForm" :rules="specsFormRules" :label-col="{ span: 8 }" :wrapper-col="{ span: 10 }">
				<a-form-model-item label="规格名称" prop="goodsSpecsName">
					<a-input v-model="specsForm.goodsSpecsName" />
				</a-form-model-item>
				<a-form-model-item label="售价" prop="goodsPrice">
					<a-input v-model="specsForm.goodsPrice" suffix="元" />
				</a-form-model-item>
				<a-form-model-item label="原价" prop="goodsOldPrice">
					<a-input v-model="specsForm.goodsOldPrice" suffix="元" />
				</a-form-model-item>
				<a-form-model-item label="库存" prop="goodsInventory">
					<a-input v-model="specsForm.goodsInventory" :suffix="form.goodsUnit" />
				</a-form-model-item>
				<a-form-model-item label="送积分" prop="goodsIntegral">
					<a-input v-model="specsForm.goodsIntegral" suffix="积分" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>

		<!-- 添加规格 -->
		<a-modal title="编辑规格" v-model="editSpecsModal" @ok="editSpecsSubmit" cancelText="取消" okText="保存" width="50%">
			<a-form-model ref="editSpecsForm" :model="editSpecsForm" :rules="specsFormRules" :label-col="{ span: 8 }"
			 :wrapper-col="{ span: 10 }">
				<a-form-model-item label="规格名称" prop="goodsSpecsName">
					<a-input v-model="editSpecsForm.goodsSpecsName" />
				</a-form-model-item>
				<a-form-model-item label="售价" prop="goodsPrice">
					<a-input v-model="editSpecsForm.goodsPrice" suffix="元" />
				</a-form-model-item>
				<a-form-model-item label="原价" prop="goodsOldPrice">
					<a-input v-model="editSpecsForm.goodsOldPrice" suffix="元" />
				</a-form-model-item>
				<a-form-model-item label="库存" prop="goodsInventory">
					<a-input v-model="editSpecsForm.goodsInventory" :suffix="form.goodsUnit" />
				</a-form-model-item>
				<a-form-model-item label="送积分" prop="goodsIntegral">
					<a-input v-model="editSpecsForm.goodsIntegral" suffix="积分" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>

		<!-- 上传图片预览 -->
		<a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
			<img alt="example" style="width: 100%" :src="previewImage" />
		</a-modal>
	</div>
</template>

<script>
	import tinymce from '@/components/tinymce.vue'
	const columns = [{
			title: '规格名称',
			dataIndex: 'goodsSpecsName',
			key: 'id',
		},
		{
			title: '售价',
			dataIndex: 'goodsPrice',
			scopedSlots: {
				customRender: 'goodsPrice'
			},
		},
		{
			title: '原价',
			dataIndex: 'goodsOldPrice',
			scopedSlots: {
				customRender: 'goodsOldPrice'
			},
		},
		{
			title: '库存',
			dataIndex: 'goodsInventory',
			scopedSlots: {
				customRender: 'goodsInventory'
			},
		},
		{
			title: '送积分',
			dataIndex: 'goodsIntegral',
			scopedSlots: {
				customRender: 'goodsIntegral'
			},
		},
		{
			title: '操作',
			dataIndex: 'action',
			scopedSlots: {
				customRender: 'action'
			},
		},
	];

	export default {
		components: {
			tinymce
		},
		data() {
			return {
				columns,
				loading: false,
				goodsClassList: [],
				fileList: [],
				form: {
					goodsUnit: '件',
					isSpecs: 1,
					goodsVirtualSales: 0,
          sort: 0,
					isOpen: true
				},
				formRules: {
					goodsName: [{
						required: true,
						message: '请填写商品名称',
						trigger: 'blur'
					}],
					goodsClass: [{
						required: true,
						message: '请选择商品分类',
						trigger: 'change'
					}],
					goodsUnit: [{
						required: true,
						message: '请填写商品单位',
						trigger: 'blur'
					}],
					goodsPrice: [{
						required: true,
						message: '请填写商品售价',
						trigger: 'blur'
					}, {
						min: 0.01,
						max: 1000,
						message: '商品售价需大于0元',
						trigger: 'blur'
					}, ],
					goodsInventory: [{
						required: true,
						message: '请填写商品库存',
						trigger: 'blur'
					}],
					goodsDelivery: [{
						required: true,
						message: '请选择送达时间',
						trigger: 'change'
					}],
				},
				previewVisible: false,
				previewImage: '',
				addSpecsModal: false,
				specsForm: {},
				specsList: [],
				specsFormRules: {
					goodsSpecsName: [{
						required: true,
						message: '请填写规格名称',
						trigger: 'blur'
					}],
					goodsPrice: [{
						required: true,
						message: '请填写商品售价',
						trigger: 'blur'
					}],
					goodsInventory: [{
						required: true,
						message: '请填写商品库存',
						trigger: 'blur'
					}],
				},
				editSpecsModal: false,
				editSpecsForm: {},
			}
		},
		mounted() {
			this.id = this.$route.query.id
			this.getDetail()
			this.getGoodsClassList()
			this.getSpecsList()
		},
		methods: {
			goodsThumbChange(info) {
				if (info.file.status === 'uploading') {
					this.loading = true;
					return;
				}
				if (info.file.status === 'done') {
					this.form.goodsThumb = info.file.response.url;
					this.loading = false;
				}
			},

			handleCancel() {
				this.previewVisible = false;
			},

			async handlePreview(fileList) {
				this.previewImage = (fileList.url ? fileList.url : fileList.response.url) || file.preview;
				this.previewVisible = true;
			},

			photoChange({
				fileList
			}) {
				this.fileList = fileList
			},

			basicSubmit() {
				// console.log(this.fileList)
				this.$refs.form.validate(valid => {
					if (valid) {
						if (!this.form.goodsThumb) {
							this.$message.error('请上传商品缩略图');
							return false
						}
						if (!this.fileList) {
							this.$message.error('请上传商品图片');
							return false
						}
						console.log(this.specsList)
						if (this.form.isSpecs == 2 && this.specsList.length == 0) {
							this.$message.error('请上传多规格商品信息');
							return false
						}
						let goodsPic = []
						for (var i = 0; i < this.fileList.length; i++) {
							goodsPic.push({
								name: this.fileList[i].name,
								size: this.fileList[i].size,
								status: this.fileList[i].status,
								url: this.fileList[i].url ? this.fileList[i].url : this.fileList[i].response.url
							});
						}
						let data = {
							id: this.id,
							goodsName: this.form.goodsName,
							goodsClass: JSON.stringify(this.form.goodsClass),
							goodsThumb: this.form.goodsThumb,
							goodsPic: JSON.stringify(goodsPic),
							goodsCont: this.form.goodsCont,
							goodsUnit: this.form.goodsUnit,
							goodsPrice: this.form.goodsPrice,
							goodsOldPrice: this.form.goodsOldPrice,
							goodsInventory: this.form.goodsInventory,
							goodsIntegral: this.form.goodsIntegral,
							isSpecs: this.form.isSpecs,
							goodsVirtualSales: this.form.goodsVirtualSales,
							sort: this.form.sort,
							isOpen: this.form.isOpen,
							goodsContent: this.form.goodsContent,
							goodsDelivery: 1,
						}
						this.$http.post('/admin/index.php/admin/Shop/goodsSave', data).then(res => {
							if (res.data.code == 1) {
								this.$message.success(res.data.msg)
								this.getDetail()
							} else {
								this.$message.error(res.data.msg)
							}
						})
					}
				});
			},

			addSpecsSubmit() {
				this.$refs.specsForm.validate(valid => {
					if (valid) {
						let data = {
							goodsId: this.id,
							goodsSpecsName: this.specsForm.goodsSpecsName,
							goodsPrice: this.specsForm.goodsPrice,
							goodsOldPrice: this.specsForm.goodsOldPrice,
							goodsInventory: this.specsForm.goodsInventory,
							goodsIntegral: this.specsForm.goodsIntegral,
						}
						this.$http.post('/admin/index.php/admin/Shop/spaceSave', data).then(res => {
							if (res.data.code == 1) {
								this.$message.success(res.data.msg)
								this.addSpecsModal = false
								this.getSpecsList()
								// this.getDetail()
							} else {
								this.$message.error(res.data.msg)
							}
						})

					}
				});
			},

			editSpecsSubmit() {
				this.$refs.editSpecsForm.validate(valid => {
					if (valid) {
						let data = {
							id: this.specsId,
							goodsId: this.id,
							goodsSpecsName: this.editSpecsForm.goodsSpecsName,
							goodsPrice: this.editSpecsForm.goodsPrice,
							goodsOldPrice: this.editSpecsForm.goodsOldPrice,
							goodsInventory: this.editSpecsForm.goodsInventory,
							goodsIntegral: this.editSpecsForm.goodsIntegral,
						}
						this.$http.post('/admin/index.php/admin/Shop/spaceSave', data).then(res => {
							if (res.data.code == 1) {
								this.$message.success(res.data.msg)
								this.editSpecsModal = false
								this.getSpecsList()
							} else {
								this.$message.error(res.data.msg)
							}
						})

					}
				});
			},

			getSpecsList() {
				let data = {
					goodsId: this.id,
				}
				this.$http.post('/admin/index.php/admin/Shop/spaceList', data).then(res => {
					if (res.data.code == 1) {
						this.specsList = res.data.data
					}
				})
			},

			viewSpecs(id) {
				this.editSpecsModal = true
				this.specsId = id
				this.$http.post('/admin/index.php/admin/Shop/spaceInfo', {
					id: id,
				}).then(res => {
					if (res.data.code == 1) {
						this.editSpecsForm = res.data.data
					}
				})
			},

			delSpecs(id) {
				this.$http.post('/admin/index.php/admin/Shop/spaceDel', {
					id: id,
				}).then(res => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg)
						this.getSpecsList()
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},

			getDetail() {
				this.$http.post('/admin/index.php/admin/Shop/goodsInfo', {
					id: this.id,
				}).then(res => {
					if (res.data.code == 1) {
						this.form = res.data.data
						this.fileList = res.data.data.goodsPic
					}
				})
			},

			getGoodsClassList() {
				this.$http.get('/admin/index.php/admin/Shop/classPullList').then(res => {
					if (res.data.code == 1) {
						this.goodsClassList = res.data.data
					}
				})
			}
		},
	}
</script>

<style scoped="">
	.classTitle {
		padding: 20px;
		text-align: center;
		font-size: 20px;
	}

	/deep/ .ant-upload-list-picture-card-container {
		width: 150px;
		height: 150px;
	}

	/deep/ .ant-upload-select-picture-card {
		width: 150px;
		height: 150px;
	}

	/deep/ .ant-upload-list-picture-card .ant-upload-list-item {
		width: 150px;
		height: 150px;
	}

	.ant-upload-select-picture-card i {
		font-size: 32px;
		color: #999;
	}

	.ant-upload-select-picture-card .ant-upload-text {
		margin-top: 8px;
		color: #666;
	}

	.events {
		list-style: none;
		margin: 0;
		padding: 0;
	}

	.events .ant-badge-status {
		overflow: hidden;
		white-space: nowrap;
		width: 100%;
		text-overflow: ellipsis;
		font-size: 12px;
	}

	.notes-month {
		text-align: center;
		font-size: 28px;
	}

	.notes-month section {
		font-size: 28px;
	}

	/deep/ .ant-fullcalendar-header .ant-radio-group {
		display: none
	}

	/* For demo */
	.ant-carousel>>>.slick-slide {
		text-align: center;
		height: 160px;
		line-height: 160px;
		background: #364d79;
		overflow: hidden;
	}

	.ant-carousel>>>.custom-slick-arrow {
		width: 25px;
		height: 25px;
		font-size: 25px;
		color: #fff;
		background-color: rgba(31, 45, 61, 0.11);
		opacity: 0.3;
	}

	.ant-carousel>>>.custom-slick-arrow:before {
		display: none;
	}

	.ant-carousel>>>.custom-slick-arrow:hover {
		opacity: 0.5;
	}

	.ant-carousel>>>.slick-slide h3 {
		color: #fff;
	}
</style>
